module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"xLabel":"Liegenschaft (sortiert nach Rentabilität der PV-Anlage)","yLabel":"Deckung Jahresbedarf Gesamtportfolio (%)","productionTooltip":"Ertrag Photovoltaik","yieldRatioTooltip":"Rendite","default":"Ertrag","descriptionTooltip":"Liegenschaft","descriptionLabel":"Liegenschaft","reductionLabel":"Ertrag in MWh","rest":"Rest","existing":"Existierend"}}')
  delete Component.options._Ctor
}
